import { useAuth } from '../../hooks/useAuth'
import { MicrosoftSignInButton } from '../MicrosoftSignInButton/MicrosoftSignInButton'
import { getLoginErrorMessage } from './LoginScreen.helpers'
import './LoginScreen.css'

export function LoginScreen() {
  const { login } = useAuth()
  const errorMessage = getLoginErrorMessage()

  return (
    <main className="login-screen">
      <section
        className="login-screen__brand"
        aria-labelledby="login-product-name"
      >
        <span className="login-screen__brand-mark" aria-hidden="true">
          ATG
        </span>
        <h1 id="login-product-name" className="login-screen__product-name">
          <span className="login-screen__product-line">
            Tenancy and Inventory
          </span>{' '}
          <span className="login-screen__product-line">Management System</span>
        </h1>
        <p className="login-screen__summary">
          Manage tenant groups, tenants, inventory system profiles, venues and
          configs for ATG Entertainment.
        </p>
      </section>

      <section className="login-screen__panel" aria-labelledby="login-heading">
        <div className="login-screen__card">
          <h2 id="login-heading" className="login-screen__heading">
            Sign in
          </h2>
          <p className="login-screen__hint">Use your ATG Microsoft account.</p>
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <MicrosoftSignInButton onClick={login} />
        </div>
      </section>
    </main>
  )
}
